const actions = {
  SET_STATE: 'program/SET_STATE',
  SHOW_PROGRAM: 'program/SHOW_PROGRAM',
  UPDATE_PROGRAM: 'program/UPDATE_PROGRAM',
}

export default actions
